import { render } from "./EditCreditPopup.vue?vue&type=template&id=28fafb4e"
import script from "./EditCreditPopup.vue?vue&type=script&lang=js"
export * from "./EditCreditPopup.vue?vue&type=script&lang=js"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__